module.exports = __webpack_public_path__ + "img/风控.dbb6ae66.jpg";